var map = {
	"./18-play-responsibly.png": 6812,
	"./18-plus-chile.png": 8797,
	"./18-plus-dk.png": 9155,
	"./18-plus-serbia.png": 4862,
	"./18-plus.png": 9045,
	"./19-plus.png": 1566,
	"./21-plus.png": 8773,
	"./24x7handsnl.png": 3890,
	"./800-gambler.png": 9928,
	"./adg-problem-gambling.png": 3245,
	"./agognl.png": 4737,
	"./bell-icon.png": 518,
	"./br-flag.png": 5310,
	"./ca-flag.png": 6174,
	"./cards.png": 7676,
	"./casino.png": 6076,
	"./check.png": 2665,
	"./cl-flag.png": 2953,
	"./close-cross.png": 66,
	"./co-flag.png": 7968,
	"./crown.png": 2256,
	"./cruksnl.png": 993,
	"./dk-flag.png": 6651,
	"./drajzerova-logo-first.png": 5342,
	"./drajzerova-logo-second.png": 746,
	"./ecogra.png": 6704,
	"./envelope-icon.png": 3655,
	"./es-flag.png": 2658,
	"./evalu-jeu.png": 9453,
	"./extern.png": 8659,
	"./facebook-icon.png": 635,
	"./fi-flag.png": 8007,
	"./football-helmet.png": 4666,
	"./fr-flag.png": 6202,
	"./gam-stop.png": 4479,
	"./gamble-aware.png": 1972,
	"./gamblers-anonymous.png": 1988,
	"./gambling-care.png": 8364,
	"./gambling-therapy.png": 2900,
	"./gamcare.png": 6907,
	"./giftbox.png": 5388,
	"./gordon-moody.png": 7879,
	"./horse.png": 9282,
	"./ie-flag.png": 2952,
	"./igc.png": 2438,
	"./info-i.png": 19,
	"./info.png": 5505,
	"./it-flag.png": 2455,
	"./jackpot.png": 9991,
	"./jogadoresanonimosbr.png": 3079,
	"./juega-bien.png": 3238,
	"./juegosysorteos-mx.png": 2172,
	"./loketkansspelnl.png": 9905,
	"./ludomani.png": 4646,
	"./mapg.png": 6028,
	"./michigan-gaming-control-board.png": 562,
	"./mx-flag.png": 6951,
	"./ncpg.png": 1127,
	"./nj-responsible-gambling.png": 9312,
	"./nl-flag.png": 4556,
	"./onjn-romania.png": 936,
	"./pa-responsible-gambling.png": 6595,
	"./pe-flag.png": 5805,
	"./pt-flag.png": 7054,
	"./rofus.png": 1784,
	"./roulette.png": 8257,
	"./rs-flag.png": 8989,
	"./safe.png": 4962,
	"./se-flag.png": 9922,
	"./segob-mx.png": 1059,
	"./serbia-ministry-of-health.png": 9832,
	"./serbia-problem-gambling.png": 5793,
	"./sicad.png": 2281,
	"./slot-machine.png": 7233,
	"./spillemyndigheden.png": 3618,
	"./srij.png": 2587,
	"./stopspillet.png": 3196,
	"./take-time-to-think.png": 9787,
	"./tick-icon.png": 8558,
	"./time.png": 7574,
	"./token.png": 9210,
	"./tracktemi.png": 6127,
	"./twitter-icon.png": 8788,
	"./uk-flag.png": 9930,
	"./usa-flag.png": 9645,
	"./viradoojogobr.png": 6140,
	"./withdrawal.png": 9776,
	"./yellowcheck.png": 6665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;